import React, {useEffect, useState, useRef} from 'react';
import {InputGroup, Input, Card, Toggle} from 'rsuite';
import { TfiSave } from 'react-icons/tfi';
import TimeControlInput from '../../../../../shared/TimeControlInput/TimeControlInput';
import {calculateArrowAngles} from "../utils/Mechaism.utils";
import moment from 'moment';
import UpdateButton from "../../../../../shared/UpdateButton/UpdateButton";
import {VscEdit} from "react-icons/vsc";
import DateTimeEditModal from "../../../../../modals/DateTimeEditModal/DateTimeEditModal";

const MechanismDataSection = ({
                                loading,
                                hourHandPosition,
                                minuteHandPosition,
                                userTimezone,
                                handleTimezoneChange,
                                deviceTime,
                                setDeviceTime,
                                onSaveUTCTime,
                                onSaveTimezone,
                                getTime,
                                setHourHandPosition,
                                setMinuteHandPosition,
                                loadMechanismInfoUpdate,
                                changeArrowsPosition,
                                isMechanismMovement,
                                movementPermission,
                                autonomousEnabled,
                                isDaylightSavingEnabled,
                                handleToggleDaylightSaving,
                                isConnected = true
                              }) => {
  const { hourAngle, minuteAngle } = calculateArrowAngles(hourHandPosition, minuteHandPosition);
  const disabled = loading || !isConnected;

  const [currentUtcDateTime, setCurrentUtcDateTime] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const timeMomentRef = useRef(null);
  const intervalRef = useRef(null);
  const [isTimeModalOpen, setIsTimeModalOpen] = useState(false);

  const getCurrentUtcDateTime = () => {
    return moment().utc().format('DD.MM.YYYY HH:mm:ss');
  };

  const getTimeMoment = (date) => {
    if (!date) return moment();

    try {
      if (typeof date === 'string') {
        return moment(date, 'DD.MM.YYYY HH:mm:ss');
      }

      if (date instanceof Date) {
        return moment(date);
      }

      if (moment.isMoment(date)) {
        return date.clone();
      }

      return moment();
    } catch (error) {
      console.error('Error creating moment:', error);
      return moment();
    }
  };

  const updateTimeFromDeviceTime = () => {
    if (deviceTime) {
      const m = getTimeMoment(deviceTime);
      timeMomentRef.current = m;
      setCurrentTime(m.format('DD.MM.YYYY HH:mm:ss'));
    } else {
      timeMomentRef.current = null;
      setCurrentTime('');
    }
  };

  useEffect(() => {
    setCurrentUtcDateTime(getCurrentUtcDateTime());

    const intervalId = setInterval(() => {
      setCurrentUtcDateTime(getCurrentUtcDateTime());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    updateTimeFromDeviceTime();

    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }

    intervalRef.current = setInterval(() => {
      if (timeMomentRef.current) {
        timeMomentRef.current.add(1, 'seconds');
        setCurrentTime(timeMomentRef.current.format('DD.MM.YYYY HH:mm:ss'));
      }
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [deviceTime]);


  const handleEditTimeClick = () => {
    setIsTimeModalOpen(true);
  };

  const handleSaveFromModal = async (newMoment) => {
    const newDate = newMoment.toDate();

    setDeviceTime(newDate);
    timeMomentRef.current = newMoment.clone();
    setCurrentTime(newMoment.format("DD.MM.YYYY HH:mm:ss"));

    await onSaveUTCTime(newDate);

    setIsTimeModalOpen(false);
  };
  const updateData = async () => {
    try {
      await getTime();
      updateTimeFromDeviceTime();
      await loadMechanismInfoUpdate();
    } catch (error) {
      console.error('Ошибка обновления данных:', error);
    }
  };



  return (
    <><Card
      style={{
        textAlign: 'center',
        opacity: !isConnected ? 0.6 : (isMechanismMovement() ? 0.5 : 1),
        pointerEvents: !isConnected ? 'none' : undefined
      }}
      className="p-1"
      header="Данные на механизме"
      bordered
    >
      <div className="row">
        <div className="col-md-12 text-end">
          <UpdateButton onRefresh={updateData}/>
        </div>
      </div>
      <div className="row p-1 pt-0">
        <div className="col-md-12 mb-1">
          <div className="clock" style={{height: 172}}>
            <img
              className="clock-face"
              src="/clock-face.svg"
              alt="Циферблат"/>
            <img
              className="clock-hand hour-hand"
              src="/hour-hand.svg"
              alt="Часовая стрелка"
              style={{transform: `rotate(${hourAngle}deg)`}}/>
            <img
              className="clock-hand minute-hand"
              src="/minute-hand.svg"
              alt="Минутная стрелка"
              style={{transform: `rotate(${minuteAngle}deg)`}}/>
          </div>
        </div>
        <div className="col-xxl-7 col-xl-12 col-lg-12 col-md-12">
          <InputGroup style={{marginBottom: '5px', width: '100%'}}>
            <InputGroup.Addon>Время</InputGroup.Addon>
            <Input
              className="bg-green"
              readOnly
              value={currentTime}
            />
            <InputGroup.Addon style={{cursor: "pointer"}} onClick={handleEditTimeClick} title="Редактировать">
              <VscEdit/>
            </InputGroup.Addon>
          </InputGroup>
        </div>
        <div className="col-xxl-5 col-xl-12 col-lg-12 col-md-12 mb-1">
          <InputGroup>
            <InputGroup.Addon>Час. пояс</InputGroup.Addon>
            <Input
              value={userTimezone}
              onChange={handleTimezoneChange}
              style={{textAlign: 'center'}}
              disabled={!isConnected}/>
            <InputGroup.Addon>
              <TfiSave
                style={{cursor: 'pointer'}}
                onClick={onSaveTimezone}/>
            </InputGroup.Addon>
          </InputGroup>
        </div>
        <div className="col-md-12">
          <div className="section-text">
            <div className="mechanism-utc-row d-flex">
              <InputGroup className="mechanism-utc-row__time" style={{marginBottom: '5px'}}>
                <InputGroup.Addon>Время UTC</InputGroup.Addon>
                <Input
                  className="bg-yellow"
                  readOnly={true}
                  value={currentUtcDateTime}/>
              </InputGroup>
              <Toggle
                className="mechanism-utc-row__toggle"
                size="sm"
                color="blue"
                checkedChildren="ON"
                unCheckedChildren="OFF"
                checked={isDaylightSavingEnabled || false}
                onChange={handleToggleDaylightSaving}
                disabled={disabled}
                loading={loading}
              >
                Авт. переход зима / лето
              </Toggle>
            </div>
            <div className="d-flex justify-content-between ">
              <div>
                <TimeControlInput
                  hour={hourHandPosition}
                  minute={minuteHandPosition}
                  onTimeChanged={(hours, minutes) => {
                    setHourHandPosition(hours);
                    setMinuteHandPosition(minutes);
                  }}
                  loading={loading}
                  onSave={changeArrowsPosition}
                  movementPermission={movementPermission}
                  autonomousEnabled={autonomousEnabled}
                  />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Card>
      <DateTimeEditModal
        open={isTimeModalOpen}
        onClose={() => setIsTimeModalOpen(false)}
        initialValue={deviceTime}
        loading={loading}
        title="Редактировать дату и время"
        onSave={handleSaveFromModal}
    />
    </>
  );
};

export default MechanismDataSection;
